module.exports = __webpack_public_path__ + "static/media/pato_big.5487c366.png";